import { type Action } from '../../interfaces'
import { COMMON_ACTIONS, SESSION_ACTIONS } from '../../utils/constants'

const getSessionCoachList = (engagementId: string): Action<string> => {
  return { type: SESSION_ACTIONS.GET_SESSION_COACH_LIST + COMMON_ACTIONS.REQUEST, data: engagementId }
}
export const coachListAction = {
  getSessionCoachList
}
